import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import style from './verify-header.module.less';
import { FormattedMessage } from 'react-intl';
import getMarketplaceDisplayName from '../../../components/data-driven-logo/get-marketplace-display-name';
import { Button } from 'ui-components/components/button';
import ReviewAdjustmentsModal from '../../../../src/orders/marketplace-adjustments/components/review-adjustments-modal/';
import ModalPortal from '../../../components/modal-portal';
import classnames from 'classnames';
import { messages } from './messages';

export const MarketplaceAdjustmentAlert = ({ marketplaceId, itemAdjustments }) => {
  const displayName = getMarketplaceDisplayName(marketplaceId);
  const [modalOpen, setIsModalOpen] = useState(false);
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const hasItemAdjustedToNonZero = (itemAdjustments || []).some((item) => item.quantity > 0);

  return (
    <div
      className={classnames(style['adjustment-wrap'], {
        [style['non-zero']]: hasItemAdjustedToNonZero,
      })}
    >
      <div className={style['icon-wrap']}>
        <FontAwesomeIcon className={style['adjustment-icon']} icon={faExclamationTriangle} />
      </div>
      <div className={style['message-wrap']}>
        <span className={style['adjustments-message']}>
          <FormattedMessage
            {...messages.shopifyAdjustedQuantityHeader}
            values={{
              displayName: displayName?.defaultMessage,
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        </span>
        <Button onClick={openModal} theme='link'>
          <FormattedMessage {...messages.shopifyAdjustedQuantityReviewLink} />
        </Button>
      </div>
      {modalOpen && (
        <ModalPortal containerId='marketplace-adjustments-modal' onClose={closeModal}>
          <ReviewAdjustmentsModal adjustments={itemAdjustments} onClose={closeModal} />
        </ModalPortal>
      )}
    </div>
  );
};

MarketplaceAdjustmentAlert.propTypes = {
  marketplaceId: PropTypes.string.isRequired,
  itemAdjustments: PropTypes.array.isRequired,
};
